import { Routes, Route } from "react-router-dom";
import Pages from "./pages";
import TaskDetails from "./features/manageTasks/TaskDetails";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/dashboard" element={<Pages.Dashboard />} />
      <Route path="/manage-employers" element={<Pages.ManageCustomers />} />
      <Route
        path="/manage-employers/detail/:id"
        element={<Pages.ManageCustomerDetail />}
      />
      <Route path="/manage-employers/add" element={<Pages.AddCustomer />} />
      <Route
        path="/manage-employers/edit/:id"
        element={<Pages.AddCustomer />}
      />
      <Route
        path="/manage-freelancer"
        element={<Pages.ManageMaintenanceTeam />}
      />
      <Route path="/manage-payout" element={<Pages.ManagePayout />} />
      <Route path="/manage-wallet" element={<Pages.ManageWallet />} />
      <Route path="/manage-payment-message" element={<Pages.ManageMessage />} />
      <Route path="/payment-fail" element={<Pages.PaymentFailure />} />
      <Route path="/manage-tasks" element={<Pages.ManageTasks />} />
      <Route
        path="/manage-freelancer/detail/:id"
        element={<Pages.MaintenanceTeamDetail />}
      />
      <Route path="/manage-freelancer/add" element={<Pages.AddTeam />} />
      <Route path="/manage-freelancer/edit/:id" element={<Pages.AddTeam />} />
      <Route path="/manage-dispute-refunds" element={<Pages.ManageIssues />} />
      <Route
        path="/manage-dispute-refunds/offers/:id/:statusType"
        element={<Pages.ManageOffers />}
      />
      <Route
        path="/manage-subadmin/detail/:id"
        element={<Pages.SubadminDetail />}
      />
      <Route path="/manage-categories" element={<Pages.ManageCategories />} />
      <Route path="/manage-payments" element={<Pages.ManagePayments />} />
      <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
      <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
      <Route path="/manage-subadmin/edit/:id" element={<Pages.AddSubadmin />} />
      {/* <Route
        path="/manage-subadmin/detail"
        element={<Pages.SubadminDetail />}
      /> */}
      <Route
        path="/manage-subadmin/roles"
        element={<Pages.ManageSubadminRoles />}
      />
      <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
      <Route
        path="/manage-subadmin/roles/edit/:id"
        element={<Pages.AddRole />}
      />
      <Route
        path="/manage-subadmin/roles/detail/:id"
        element={<Pages.RoleDetail />}
      />
      {/* <Route path="/revenue-analytics" element={<Pages.ManageAnalytics />} /> */}
      <Route path="/manage-reports" element={<Pages.ManageCustomerSupport />} />
      <Route
        path="/manage-notifications"
        element={<Pages.ManageNotifications />}
      />
      <Route
        path="/recieved-notifications"
        element={<Pages.RecievedNotifications />}
      />
      <Route path="/manage-reviews" element={<Pages.ManageReviews />} />
      <Route path="/manage-cms" element={<Pages.ManageCms />} />
      <Route path="/manage-profile" element={<Pages.ManageProfile />} />
      <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
      <Route
        path="/manage-profile/change-password"
        element={<Pages.ChangePassword />}
      />
      <Route
        path="/task-detail/:employerId/:id"
        element={<Pages.TaskDetail />}
      />
      <Route path="/task_details/:employerId/:id" element={<TaskDetails />} />
      <Route
        path="/manage-freelancer/portfolio-detail/:id"
        element={<Pages.PortfolioDetails />}
      />
      <Route
        path="/manage-categories/subcategory/:id"
        element={<Pages.ViewCategory />}
      />
      <Route
        path="/manage-categories/services/:id/:cateId"
        element={<Pages.ServiceList />}
      />
      <Route
        path="/manage-freelancer/work-history/:freelancerId/:workId"
        element={<Pages.ViewWorkHistory />}
      />
      <Route
        path="/manage-freelancer/portfolio/edit/:id/:ProjectId"
        element={<Pages.EditPorfolio />}
      />
    </Routes>
  );
};

export default Routing;
